import * as Yup from 'yup';
import i18n from 'i18n';
import { engNumChar } from 'components/Common/InputBox/validator';
import * as validator from 'components/Common/InputBox/validator';

Yup.addMethod(Yup.string, 'engNumChar', engNumChar);
Yup.addMethod(Yup.string, 'noSpaceInFront', validator.noSpaceInFront);

export const GnbMenuSchema = () => {
  return Yup.object().shape({
    titleKo: Yup.string().required('MB_M_REQUIRED').noSpaceInFront(),
    titleEn: Yup.string().required('MB_M_REQUIRED').engNumChar('MB_M_ONLY_ENG_NUM').noSpaceInFront(), // 필수값, 영문과 숫자만 가능 한글불가능, // 필수값
    urlParameter: Yup.string().required('MB_M_REQUIRED').noSpaceInFront(),
  });
};

export const GnbGroupMenuSchema = () => {
  return Yup.object().shape({
    titleKo: Yup.string().required('MB_M_REQUIRED').noSpaceInFront(),
    titleEn: Yup.string().required('MB_M_REQUIRED').engNumChar('MB_M_ONLY_ENG_NUM').noSpaceInFront(), // 필수값, 영문과 숫자만 가능 한글불가능, // 필수값
    pageList: Yup.array().min(1, i18n.t('BRY_W_T_SUBMENU_REQUIRED')),
  });
};
